import "owl.carousel/dist/owl.carousel.min";
import "owl.carousel2.thumbs"

// import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';
// import "bootstrap/dist/js/bootstrap.min";

// import '@popperjs/core/dist/umd/popper.min';

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from "photoswipe";
// import PhotoSwipeDeepZoom from 'photoswipe-deep-zoom-plugin'

jQuery(document).ready(function ($) {
  // Initialize Owl Carousel
  $('.banner-image-carousel').owlCarousel({
    loop: true,
    nav: false,
    items: 1,
    dots: false,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: false
  });

  $('.solution-carousel').owlCarousel({
    loop: true,
    nav: true,
    items: 1,
    dots: false,
    navText: ["<i class='fa-solid fa-angle-left'>", "<i class='fa-solid fa-angle-right'>"],
    thumbs: true,
    thumbImage: false,
    thumbsPrerendered: true,
    thumbContainerClass: 'owl-thumbs',
    thumbItemClass: 'owl-thumb-item',

  });

  $(".client-carousel").owlCarousel({
    margin: 10,
    loop: false,
    autoWidth: true,
    items: 1,
    autoplay: true,
    dots: false,
  });

  $(".testimonial-carousel").owlCarousel({
    margin: 10,
    loop: true,
    items: 1,
    autoplay: true,
  });

  $(".mobile-menu-toggle").click(function () {
    $(".side-nav").addClass("opened");
  });
  $(".close-btn").click(function () {
    $(".side-nav").removeClass("opened");
  });

  // Popup functionality
  const $popupOverlay = $("#popupOverlay");
  const $secondsDisplay = $("#seconds");

  // Set how long the popup will show (5 seconds)
  let timeLeft = 5;
  let timerInterval;

  // Function to update the countdown timer
  function updateTimer() {
    $secondsDisplay.text(timeLeft);

    if (timeLeft > 0) {
      timeLeft--;
    } else {
      closePopupOverlay();
    }
  }

  // Function to show the popup
  function showPopupOverlay() {
    $popupOverlay.addClass("active");
    timerInterval = setInterval(updateTimer, 1000);
  }

  // Function to close the popup
  function closePopupOverlay() {
    $popupOverlay.removeClass("active");
    clearInterval(timerInterval);
  }

  // Show the popup after .2 seconds
  setTimeout(showPopupOverlay, 200);

  // Event handlers
  $("#closePopup").click(closePopupOverlay);

  // Close popup when clicking outside the image
  $popupOverlay.click(function (e) {
    if (e.target === this) {
      closePopupOverlay();
    }
  });

  // Close popup when pressing Escape key
  $(document).keyup(function (e) {
    if (e.key === "Escape") {
      closePopupOverlay();
    }
  });

  //=== Latest post popup
  // Check session storage on page load
  if (sessionStorage.getItem('latestPostClosed') !== 'true') {
    $("#latestPost").addClass("active");
  }

  // Latest Post Toggle
  $("#latestPostCloseBtn").click(function () {
    $("#latestPost").removeClass("active");
    sessionStorage.setItem('latestPostClosed', 'true');
  });

  //=== Consultation Popup
  // Check session storage on page load
  if (sessionStorage.getItem('consultationClosed') !== 'true') {
    setTimeout(function () {
      $("#popupt_consulting").addClass("active");
    }, 500)
  }

  // Consultation Popup Toggle
  $("#popup_consulting_close").click(function () {
    $("#popupt_consulting").removeClass("active");
    sessionStorage.setItem('consultationClosed', 'true');
  });

  // Static values (Pre-filled/Hidden) - These are fine to get on page load
  // Use .text() for <p> and .val() for <input>
  var $consultingPrewrite = $("#consulting_prewrite").text();
  var $consultationTelegramUrl = $("#consultation_telegram_url").val();
  var $consultationWhatsappUrl = $("#consultation_whatsapp_url").val();

  // --- TELEGRAM BUTTON ---
  $("#consultation_telegram").click(function () {
    // Get the LIVE value that the user just typed
    var currentMessage = $("#message_input").val();

    var fullMessage = encodeURIComponent($consultingPrewrite + ' ' + currentMessage);
    window.location.href = $consultationTelegramUrl + '?text=' + fullMessage;
  });

  // --- WHATSAPP BUTTON ---
  $("#consultation_whatsapp").click(function () {
    // Get the LIVE value here too
    var currentMessage = $("#message_input").val();

    var fullMessage = encodeURIComponent($consultingPrewrite + ' ' + currentMessage);
    // Note: WhatsApp usually uses 'text' or 'phone&text' depending on the URL format
    window.location.href = $consultationWhatsappUrl + '?text=' + fullMessage;
  });

  // Home client ticker scroll
  var $ticker = $('#client-ticker');

  // 1. Clone the content to create the infinite loop effect
  var $logos = $ticker.children().clone();
  $ticker.append($logos);

  var scrollLeft = 0;
  var speed = 1; // Adjust this number to change speed (0.5 is slower, 2 is faster)
  var paused = false;

  function step() {
    if (!paused) {
      scrollLeft += speed;

      // 2. Reset to 0 when we've scrolled past the first full set of logos
      // We use the scrollWidth of the original content (half of the new total width)
      if (scrollLeft >= $ticker[0].scrollWidth / 2) {
        scrollLeft = 0;
      }

      $ticker.scrollLeft(scrollLeft);
    }
    window.requestAnimationFrame(step);
  }

  // 3. Start the animation
  window.requestAnimationFrame(step);

  // 4. Optional: Pause on hover
  $ticker.on('mouseenter', function () { paused = true; });
  $ticker.on('mouseleave', function () { paused = false; });


});

// Solution slider lightbox with Zoom

const lightbox = new PhotoSwipeLightbox({
  gallery: '#solution_carousel',
  children: '.pswp-gallery__item',
  pswpModule: PhotoSwipe,

  // Recommended PhotoSwipe options for this plugin
  allowPanToNext: false, // prevent swiping to the next slide when image is zoomed
  allowMouseDrag: true, // display dragging cursor at max zoom level
  wheelToZoom: true, // enable wheel-based zoom
  zoom: true // disable default zoom button
});

// const deepZoomPlugin = new PhotoSwipeDeepZoom(lightbox, {
//   // deep zoom plugin options, for example:
//   tileSize: 256
// });

lightbox.init();

